/*******************************************************************************
CHARTIST DRAW PROCESSING
This returns a function that can be used to change how a chart is drawn on screen.
*******************************************************************************/

import getKeyData from './get-key-data-points';
import getLimitMode from './get-limit-mode';

export default function onDrawChartist(chartName, dataSets, options = {}) {
    const drawOptions = $.extend(true, {}, options.rw);
    drawOptions.labelClass = options.labelClass;

    const {
        labelDecimals = 0,
        labelClass = 'ct-point-label',
        drawLabelOffsetX = -10,
        drawLabelOffsetY = -10,
        labelStyle = '',
        flipDataSign = false,
    } = drawOptions;
    const $chart = $(`#chart${chartName}`);
    let chartWidth;

    const keyData = getKeyData(dataSets);
    const numData = dataSets.reduce((a, b) => (a.length > b.length ? a : b), []).length;

    let isEveryOther = true;

    return (data) => {
        if (data.type === 'point') {
            if (data.index === 0) { chartWidth = $chart.width(); }

            const limit = getLimitMode(chartWidth, numData);
            const isKeyDataPoint = keyData.flat().map(d => d.meta).includes(data.meta);

            // Figure out if the data point dot should be displayed
            const displayDot = (limit === 'all') || (limit === 'key' && isKeyDataPoint) || (limit === 'everyOther' && isEveryOther === true);

            // Flip the isEveryOther variable so the next dot has the opposite visibility
            isEveryOther = !isEveryOther;

            if (displayDot) {
                const val = flipDataSign ? -data.value.y : data.value.y;
                data.group
                    .elem('text', {
                        x    : data.x + Number(drawLabelOffsetX),
                        y    : data.y + Number(drawLabelOffsetY),
                        style: labelStyle,
                    }, labelClass)
                    .text(Number(val).toFixed(labelDecimals));
            }
            else {
                data.element.remove();
            }
        }
    };
}
